
import { applicantStore } from '@/store'
import { ValidationObserver } from 'vee-validate'
import { Component } from 'vue-property-decorator'
import { Address } from '@/commons/constants/address'
import InputWithLabel from '@/commons/components/core/InputWithLabel.vue'
import PersonContactsForeignAddress from './PersonContactsForeignAddress.vue'
import PersonContactsEstonianAddress from './PersonContactsEstonianAddress.vue'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import RadioButtonRounded from '@/commons/components/core/RadioButtonRounded.vue'

import {
    validatorIds,
    ContactValidationFieldName
} from '@/commons/constants/application'

import {
    ApplicationContact,
    ApplicationContactAddress,
    LocaleMessageWithParams,
    ValidationError
} from '@/commons/types'

@Component({
    components: {
        RadioButtonRounded,
        InputWithLabel,
        PersonContactsEstonianAddress,
        PersonContactsForeignAddress
    }
})
export default class PersonContacts extends ValidationObserver {
    domValidatorIds = validatorIds
    phoneNumberValidatorId = ContactValidationFieldName.PHONE_NUMBER
    emailValidatorId = ContactValidationFieldName.EMAIL

    addressType: string = Address.ESTONIAN

    created (): void {
        const address = this.contact.address
        // check if there is unfinished application, otherwise estonian address is default selection
        if (address.adsAdrId && address.adsOid) {
            this.addressType = Address.ESTONIAN
        } else if (address.country) {
            this.addressType = Address.FOREIGN
        }
    }

    setEmail (value: string): void {
        this.contact.email = value || null
    }

    setPhoneNumber (value: string): void {
        this.contact.phoneNumber = value || null
    }

    get phoneNumberRequirements (): Array<LocaleMessageWithParams> {
        return [
            {
                templateKey: 'personContacts.phoneNumberRequirements.minLength'
            },
            {
                templateKey: 'personContacts.phoneNumberRequirements.maxLength'
            },
            {
                templateKey: 'personContacts.phoneNumberRequirements.countryCode'
            }
        ]
    }

    get fullAddress (): string {
        return applicantStore.addressWithPostalCode
    }

    get contact (): ApplicationContact {
        return applicantStore.applicationContact
    }

    get isEstonianAddress (): boolean {
        return this.addressType === this.estonianAddress
    }

    get estonianAddress (): string {
        return Address.ESTONIAN
    }

    get foreignAddress (): string {
        return Address.FOREIGN
    }

    get address (): ApplicationContactAddress {
        return applicantStore.applicationContact.address
    }

    clearEstonianAddress (): void {
        this.address.postalCode = null
        this.address.adsOid = null
        this.address.adsAdrId = null
        this.address.fullAddress = null
        this.address.notes = null
    }

    clearForeignAddress (): void {
        this.address.country = null
        this.address.stateOrProvinceOrCounty = null
        this.address.city = null
        this.address.street = null
        this.address.postalCode = null
        this.address.fullAddress = null
        this.address.notes = null
    }

    setAddressType (value: string) {
        this.addressType = value
        this.address.fullAddress = ''
        if (value === this.estonianAddress) {
            this.clearForeignAddress()
        } else {
            this.clearEstonianAddress()
        }
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }
}
